module.exports = __webpack_public_path__ + "img/paibian-mu.78cc294e.png";